import { useDispatch } from 'react-redux';

import priceToPaymentButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/price/price_to_payment_button_click';
import { Button } from '@hh.ru/magritte-ui';
import { usePush } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { purchase } from 'src/api/price/cart';
import { useNotification } from 'src/components/Notifications/Provider';
import translation from 'src/components/translation';
import { AppDispatch } from 'src/models/appDispatch';

const DATA_QA = 'cart__button-go-to-payment';

const TrlKeys = {
    checkout: 'employer.price2.checkout',
};

const PriceCartPayButton: TranslatedComponent = ({ trls }) => {
    const dispatch: AppDispatch = useDispatch();
    const { addNotification } = useNotification();
    const push = usePush();

    return (
        <Button
            mode="primary"
            stretched
            size="medium"
            onClick={() => {
                void dispatch(purchase({ hhtmFromLabel: 'price_cart_purchase_button' }, addNotification, push));
                priceToPaymentButtonClick();
            }}
            style="accent"
            data-qa={DATA_QA}
        >
            {trls[TrlKeys.checkout]}
        </Button>
    );
};

export default translation(PriceCartPayButton);
